import React, { useState } from "react";
import Style from "./TermsofUse.module.scss";
import Button from "react-bootstrap/Button";
import Assets from "../../Layout/Assets";
import Container from "react-bootstrap/Container";
import InsideIndia from "./InsideIndia";
import Gericareterms from "./Gericare"
import OutSideIndia from "./OutsideIndia";
function Termsofuse() {
  const [insideIndia, setTerms] = useState(true);
  const clientDetails = JSON.parse(localStorage.getItem("ClinicDetails"));
  const [isgericare, setIsgericares] = useState(clientDetails!=undefined && clientDetails.clinicurl==="gericare"?true:false);
  
  return (
    <Container>
    <div className={Style.termsofUse}>
      <div className={Style.btn_wrapper}>
      {isgericare?null
          :<>
        <Button
          variant="secondary"
          className={`${Style.btn_1} ${insideIndia ? Style.active_btn1 : ""}`}
          onClick={() => setTerms(true)}
        >
          For patients from India
        </Button>
        <Button
          variant="secondary"
          className={`${Style.btn_1} ${
            !insideIndia ? Style.active_btn1 : ""
          }`}
          onClick={() => setTerms(false)}
        >
          For patients from Rest of the World
        </Button>
        </>
      }
      </div>
      { isgericare?<Gericareterms/>:
      insideIndia ? <InsideIndia /> : <OutSideIndia />}
    </div>
  </Container>
  );
}

export default Termsofuse;
